import { ErrorHandler } from '@angular/core';

export class ExceptionHandler implements ErrorHandler {
	public handleError(error) {
		console.error(error);
	}
}
